/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const SetCustomerOfferChapterCommercialOptionsRequest = zod
  .object({
    optional: zod.boolean(),
    applyCommission: zod.boolean(),
  })
  .describe(
    "Two explicit JSON booleans, preserving false. Missing, null, nonboolean, duplicate or unexpected properties are rejected before dispatch. Optional Chapters remain individually quoted and fully validated but do not contribute to ordinary Offer aggregates. Commission exemption preserves the selected agreement and does not repair invalid sources.",
  );

export type SetCustomerOfferChapterCommercialOptionsRequest = zod.input<
  typeof SetCustomerOfferChapterCommercialOptionsRequest
>;
export type SetCustomerOfferChapterCommercialOptionsRequestOutput = zod.output<
  typeof SetCustomerOfferChapterCommercialOptionsRequest
>;
